import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"
import { useCallback } from "react"
import { useSelector } from "react-redux"

/**
 * Dit aux tuteurs du live que l'élève vient de rendre une activité : c'est ce
 * qui fait monter la pastille de l'élève dans leur liste. Hors live, ne fait
 * rien.
 */
const useAnnounceActivityFinalized = () => {
    const { sendLiveKitData } = useLiveKitEventSender()
    const isLive = useSelector((state) => state.liveMode?.isLiveModeEnabled)
    const displayName = useSelector(
        (state) => state.data.currentUser?.object?.display_name
    )
    const liveSession = useSelector((state) =>
        state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        )
    )

    return useCallback(
        (activity) => {
            if (!isLive) return

            const tutorIds = liveSession?.users
                ?.filter((l) => l?.is_tutor)
                ?.map((l) => l?.id)

            sendLiveKitData(
                "activityFinalized",
                { displayName, activityId: activity?.id },
                tutorIds?.length > 0 ? tutorIds : null
            )
        },
        [sendLiveKitData, isLive, displayName, liveSession]
    )
}

export default useAnnounceActivityFinalized
